/**
 * Ouvre / ferme les <dialog data-subscription-info-dialog> du panneau produit.
 * Verrouille le scroll de html/body tant qu’au moins une modale est ouverte.
 */
(function () {
  if (window.regloSubscriptionInfoDialogInit) return;
  window.regloSubscriptionInfoDialogInit = true;

  var SCROLL_LOCK_CLASS = 'reglo-subscription-dialog-scroll-lock';

  function syncScrollLock() {
    var shouldLock = false;
    document.querySelectorAll('dialog[data-subscription-info-dialog]').forEach(function (d) {
      if (d.open) shouldLock = true;
    });
    document.documentElement.classList.toggle(SCROLL_LOCK_CLASS, shouldLock);
    document.body.classList.toggle(SCROLL_LOCK_CLASS, shouldLock);
  }

  function wireDialog(d) {
    if (d.dataset.regloScrollLockWired) return;
    d.dataset.regloScrollLockWired = '1';
    d.addEventListener('close', syncScrollLock);
    d.addEventListener('cancel', syncScrollLock);
  }

  function wireAllDialogs(root) {
    var scope = root || document;
    scope.querySelectorAll('dialog[data-subscription-info-dialog]').forEach(wireDialog);
  }

  function init() {
    wireAllDialogs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelectorAll) wireAllDialogs(ev.target);
  });

  document.addEventListener(
    'click',
    function (e) {
      var open = e.target.closest && e.target.closest('[data-subscription-info-open]');
      if (open) {
        var root = open.closest('[data-subscription-info-dialog-root]');
        var dialog = root && root.querySelector('dialog[data-subscription-info-dialog]');
        if (dialog) {
          e.preventDefault();
          dialog.showModal();
          syncScrollLock();
        }
        return;
      }

      var t = e.target;
      if (t && t.matches && t.matches('dialog[data-subscription-info-dialog]')) {
        if (e.target === t) {
          t.close();
        }
      }
    },
    false
  );
})();
